import React, {Component} from 'react';
import {Col, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import Select from "../../../local_node_modules/react-select"
import {deepCopyObject, getNaceCodes, showAxiosError} from "../../../helper/helper";
import Alert from "react-s-alert";
import {request} from "../../../helper/APIUtils";
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';
import {isValidTckn} from '../../../helper/TCKimlikNoValidator';
import {isValidVergiKimlik} from '../../../helper/VergiKimlikNoValidator';
import {EntegratorConf, VirtualHost} from "../../../constants";
import {EntegratorIdentifiers} from "../../../helper/enums";
import NumberFormat from "react-number-format";
import FaultyDocumentModal from "./FaultyDocumentModal";
import {showBaro, showDistributorAllowCreditChange, showKolayAndSmart} from "../../../helper/permission";
import InformationMailModal from "./InformationMailModal";
import Switch from 'react-switch';

class CustomerGeneralInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			error: {},
			naceModal: false,
			selectedDistributor: {
				value: null,
				label: null
			},
			distributorList: [],
			filteredDistributorList:[],
			isCustomerEntegrator: false,
		};

		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.closeNaceModal = this.closeNaceModal.bind(this);
		this.onDistributorChange = this.onDistributorChange.bind(this);
		this.getSelectedDistributor = this.getSelectedDistributor.bind(this);
		this.getDistributors = this.getDistributors.bind(this);
		this.getDistributorName = this.getDistributorName.bind(this);
		this.informationMailChange = this.informationMailChange.bind(this);
		this.isParentCustomerEntegrator = this.isParentCustomerEntegrator.bind(this);
	}

	componentDidMount(){
		this.isParentCustomerEntegrator();
		this.getDistributors();
	}

	 isParentCustomerEntegrator() {
		let self = this;
		let parentCustomerId = self.props.customer.parentCustomerId;
		if(parentCustomerId !== null ){
			let params = {
				url: "/customer/isParentCustomerEntegrator",
				method: "post",
				data: parentCustomerId
			};
			request(params)
				.then(response => {
					this.setState({isCustomerEntegrator: response.data})
				}).catch(error => {
				showAxiosError(error);
			});
		}else{
			this.setState({isCustomerEntegrator: true})
		}
	}

	async getDistributors() {
		let self = this;
		let params = {
			url: "/customer/getDistributors",
			method: "get"
		};
		await request(params)
			.then(response => {
				this.sortDistributors(response.data);
				self.setState({distributorList: response.data, filteredDistributorList: response.data});
				if (self.props.customer.parentCustomerId !== null)
					self.getSelectedDistributor();
			}).catch(error => {
			});
	}

	sortDistributors(data) {
		return data.sort((a, b) => {
			const nameA = (a[3] + a[4]).toLowerCase();
			const nameB = (b[3] + b[4]).toLowerCase();

			return nameA.localeCompare(nameB, 'tr');
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	async getSelectedDistributor() {
		let self = this;
		let params = {
			url: "/customer/getSelectedDistributor",
			method: "post",
			data: self.props.customer.parentCustomerId
		};
		await request(params)
			.then(response => {
				let selectedDistributor = deepCopyObject(self.state.selectedDistributor);
				selectedDistributor.value = response.data.recordId;
				selectedDistributor.label = response.data.customerName;
				self.setState({selectedDistributor});
			}).catch(error => {
			});
	}

	onDistributorChange(e) {
		let selectedDistributor = deepCopyObject(this.state.selectedDistributor);
		selectedDistributor.value = e.value;
		selectedDistributor.label = e.label;
		this.setState({selectedDistributor});
		this.props.onDistributorChange(e);
	}

	handleSearch(inputValue) {
		const filteredList = this.state.distributorList.filter(distributor =>
			this.getDistributorSearchName(distributor).toLowerCase().includes(inputValue.toLowerCase())
		);

		this.setState({filteredDistributorList: filteredList});
	}

	getDistributorSearchName(distributor) {
		const fullName = this.getDistributorName(distributor);
		const nameParts = fullName.split('(');
		return nameParts[0].trim();
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	prepareCustomValue(e) {
		return e.customValue
	}

	errorForVknTckn() {
		let tVknTckn = {
			valid: false,
			message: "Girdiğiniz VKN/TCKN* Geçersiz!"
		};
		let error = deepCopyObject(this.state.error);
		error.tVknTckn = tVknTckn;
		this.setState({
			error
		});
		Alert.error('Girdiğiniz VKN/TCKN* Geçersiz!', {
			html: true,
			position: 'top-right',
			effect: 'stackslide',
			timeout: 5000
		})
	}

	onVknBlur(e) {

		let error = deepCopyObject(this.state.error);
		this.validateField(e);
		if (!!this.props.customer.vknTckn) {
			this.checkIfVknExists(this.props.customer.vknTckn);
		}

		if (this.props.customer.vknTckn != null && this.props.customer.vknTckn.length === 10) {

			if (!isValidVergiKimlik(this.props.customer.vknTckn)) {
				this.errorForVknTckn();
			} else {
				if (error.tVknTckn) {
					delete error.tVknTckn;
					this.setState({error});
				}
			}

		} else if (this.props.customer.vknTckn != null && this.props.customer.vknTckn.length === 11) {

			if (!isValidTckn(this.props.customer.vknTckn)) {
				this.errorForVknTckn();
			} else {
				if (error.tVknTckn) {
					delete error.tVknTckn;
					this.setState({error});
				}
			}

		} else if (this.props.customer.vknTckn != null
			&& this.props.customer.vknTckn.length < 10
			&& this.props.customer.vknTckn.length > 0) {
			this.errorForVknTckn();
		}

		if (e.target.value.length === 10) {
			if (error.tGivenName) {
				delete error.tGivenName;
				this.setState({error})
			}
			if (error.tFamilyName) {
				delete error.tFamilyName;
				this.setState({error})
			}
		}
		if (e.target.value.length === 11) {
			if (error.tFormattedName) {
				delete error.tFormattedName;
				this.setState({error})
			}
		}
	}


	checkIfVknExists(value) {
		let self = this;
		const data = value;
		let params = {
			url: `/customer/findByVknTckn`,
			data: data,
			method: 'post'
		};
		request(params).then(function (response) {
			if (response.data) {
				let tVknTckn = {
					valid: false,
					message: "Bu Vkn/Tckn'li Müşteri Zaten Mevcut"
				};
				let error = deepCopyObject(self.state.error);
				error.tVknTckn = tVknTckn;
				self.setState({
					error
				});
				Alert.error('Bu Vkn/Tckn\'li Müşteri Zaten Mevcut', {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	showNaceOption(e) {
		this.setState({
			selectedNaceOption: e.label,
			naceModal: true
		})
	}

	closeNaceModal() {
		this.setState({naceModal: false, selectedNaceOption: null})
	}

	onCheckDistributor(e) {
		let error = deepCopyObject(this.state.error);

		if (this.props.name && this.props.name === 'createEditCustomer') {
			if (!e.target.checked && error.tInvoiceDirection) {
				delete error.tInvoiceDirection;
				this.setState({error})
			}
			if(!e.target.checked && error.workingType) {
				delete error.workingType;
				this.setState({error})
			}
		}

		this.props.onChangeCustomer(e)
	}

	isCustomerAliasRegistered() {
		let customerContractList = deepCopyObject(this.props.customer.customerContractList);
		let isRegistered = false;

		if (customerContractList) {
			customerContractList.map((cc) => {
				cc.customerContractServiceList.map((ccs) => {
					if (ccs.service && (ccs.service.recordId === 2 || ccs.service.recordId === 7 || ccs.service.recordId === 8)) {
						ccs.aliasList.map((ccsa) => {
							if (ccsa.gibRegistrationState) {
								isRegistered = true;
							}
						})
					}
				})
			});
		}

		return isRegistered;
	}

	selectStyle(item) {
		let error = deepCopyObject(this.state.error);
		if (error[item] === undefined || error[item].valid) {
			return null;
		} else {
			return {backgroundColor: '#f8f8f8', borderColor: '#ffcfcf'}
		}
	}

	getDistributorName(distributor) {
		//cu=customer, 0=cu_reccordId, 1=cu_vknTckn, 2=cu_formattedName,3=cu_givenName, 4=cu_familyName,
		//pcu=parentCustomer, 5=pcu_vknTckn, 6=pcu_formattedName, 7=pcu_givenName, 8=pcu_familyName
		if (distributor) {
			if(VirtualHost.conf.resourcePrefix === 'vega')
				return (distributor[1] !== this.state.distributorList[0][1] && distributor[5] !== this.state.distributorList[0][1]) ?
					(distributor[2]) + (' (' + (distributor[5].length === 10 ? distributor[6] : (distributor[7].trimEnd() + ' ' + distributor[8])) + ')') :
					(distributor[2]);
			else
				return (distributor[1] !== this.state.distributorList[0][1] && distributor[5] !== this.state.distributorList[0][1]) ?
					(distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4])) + (' (' + (distributor[5].length === 10 ? distributor[6] : (distributor[7].trimEnd() + ' ' + distributor[8])) + ')') :
					(distributor[1].length === 10 ? distributor[2] : (distributor[3].trimEnd() + ' ' + distributor[4]));
		} else {
			return "";
		}
	}

	informationMailChange(info){
		this.props.onChangeCustomer({target: {name:"informationMail",value: info}});
	}

	render() {
		let customerTypes = [
			{value: 1, label: "Kamu"},
			{value: 2, label: "Özel"}
		];

		if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
			customerTypes.push({value: 3, label: "VUK507 Kamu"});
			customerTypes.push({value: 4, label: "VUK507 Özel"});
		}

		const customerStatus = [
			{value: false, label: "Pasif"},
			{value: true, label: "Aktif"}
		];

		return (
			<div className="col-sm-12 card-body">
				{/*<div className="card-header card-header-danger" style={{marginBottom: '40px'}}>*/}
				{/*<h4 className="card-title">Müşteri Genel Bilgileri</h4>*/}
				{/*</div>*/}

				<div className="card-body">

					<div className="row">
						<div className="col-sm-6 row ">
							<div className="col-sm-4">
								<label>VKN/TCKN*</label>
							</div>
							{this.props.mode === 'edit' &&
							<div className="col-sm-8" style={{textAlign: 'left', color: '#ff0000'}}>
								<label>{this.props.customer.vknTckn ? this.props.customer.vknTckn : ''}</label>
							</div>}
							{this.props.mode === 'create' &&
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<div className={"form-group" + this.validateClass('tVknTckn')}>
									<input className="form-control"
										   maxLength="11"
										   type="text"
										   name="vknTckn"
										   id="tVknTckn"
										   data-vlength="10,11"
										   data-vdata="identifier"
										   onBlur={(e) => this.onVknBlur(e)}
										   ref="tVknTckn"
										   value={this.props.customer.vknTckn ? this.props.customer.vknTckn : ''}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tVknTckn') !== "" &&
									<UncontrolledTooltip placement="right" target="tVknTckn" delay={0}>
										{this.validateMessage("tVknTckn")}
									</UncontrolledTooltip>}
								</div>
							</div>}
						</div>
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Müşteri Adı *</label>
							</div>
							<div className="col-sm-8">
								<div className={"form-group" + this.validateClass('tCustomerName')}>
									<input className="form-control"
										   type="text"
										   name="customerName"
										   id="tCustomerName"
										   data-vlength="1,350"
										   onBlur={this.validateField}
										   ref="tCustomerName"
										   value={this.props.customer.customerName ? this.props.customer.customerName : ''}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tCustomerName') !== "" &&
									<UncontrolledTooltip placement="right" target="tCustomerName" delay={0}>
										{this.validateMessage("tCustomerName")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						{(this.props.customer.vknTckn === null || this.props.customer.vknTckn.length !== 11) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Unvan *</label>
							</div>

							{this.props.mode === 'edit' &&
							<div className="col-sm-8">
								{this.props.isEntegrator ?
									<input className="form-control"
										   type="text"
										   name="formattedName"
										   id="tFormattedName"
										   data-vlength="1,350"
										   onBlur={this.validateField}
										   ref="tFormattedName"
										   value={this.props.customer.formattedName ? this.props.customer.formattedName : ''}
										   onChange={(e) => this.props.onChangeCustomer(e)}/> :
									<label>{this.props.customer.formattedName ? this.props.customer.formattedName : ''}</label>}
							</div>}

							{this.props.mode === 'create' &&
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<div className={"form-group" + this.validateClass('tFormattedName')}>
									<input className="form-control"
										   readOnly={this.props.mode === 'edit'}
										   type="text"
										   name="formattedName"
										   id="tFormattedName"
										   data-vlength="1,350"
										   onBlur={this.validateField}
										   ref="tFormattedName"
										   value={this.props.customer.formattedName ? this.props.customer.formattedName : ''}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tFormattedName') !== "" &&
									<UncontrolledTooltip placement="right" target="tFormattedName"
														 delay={0}>
										{this.validateMessage("tFormattedName")}
									</UncontrolledTooltip>}
								</div>
							</div>}
						</div>}

						{this.props.customer.vknTckn !== null && this.props.customer.vknTckn.length === 11 &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Unvan</label>
							</div>

							{this.props.mode === 'edit' &&
							<div className="col-sm-8">
								{this.props.isEntegrator || (this.props.name === 'companyProfile' && this.props.currentUser.customerId === this.props.customer.recordId) ?
									<input className="form-control"
										   type="text"
										   name="formattedName"
										   value={this.props.customer.formattedName ? this.props.customer.formattedName : ''}
										   onChange={(e) => this.props.onChangeCustomer(e)}/> :
									<label> {this.props.customer.formattedName ? this.props.customer.formattedName : ''}</label>}
							</div>}

							{this.props.mode === 'create' &&
							<div className="col-sm-8 form-group">
								<input className="form-control"
									   type="text"
									   name="formattedName"
									   value={this.props.customer.formattedName ? this.props.customer.formattedName : ''}
									   onChange={(e) => this.props.onChangeCustomer(e)}/>
							</div>}
						</div>}

						{this.props.name === 'createEditCustomer' &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Müşteri Tipi *</label>
							</div>
							<div className="col-sm-8">
								<div className={"form-group" + this.validateClass('tCustomerType')}>
									<Select
										clearable={false}
										className="select-control"
										name="customerType"
										id="tCustomerType"
										onBlur={() => this.validateField({
											target: {
												id: "tCustomerType",
												dataset: {vdata: "required"},
												value: this.props.customer.customerType
											}
										})}
										inputProps={{'vdata': "customerType", 'vlength': "1,45"}}
										ref="tCustomerType"
										value={this.props.customer.customerType}
										placeholder="Seçiniz..."
										style={this.selectStyle('tCustomerType')}
										onChange={(e) => e && this.props.onCustomerTypeChange(e)}
										options={customerTypes}
									/>
									{this.validateMessage('tCustomerType') !== "" &&
									<UncontrolledTooltip placement="right" target="tCustomerType" delay={0}>
										{this.validateMessage("tCustomerType")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>}
					</div>


					<div className="row">
						{(this.props.customer.vknTckn !== null && this.props.customer.vknTckn.length === 11 && !this.isCustomerAliasRegistered()) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Adı *</label>
							</div>
							<div className="col-sm-8">
								<div className={"form-group" + this.validateClass('tGivenName')}>
									<input className="form-control"
										   type="text"
										   name="givenName"
										   id="tGivenName"
										   data-vlength="1,45"
										   onBlur={this.validateField}
										   ref="tGivenName"
										   value={this.props.customer.givenName}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tGivenName') !== "" &&
									<UncontrolledTooltip placement="right" target="tGivenName" delay={0}>
										{this.validateMessage("tGivenName")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>}

						{((this.props.customer.vknTckn === null || this.props.customer.vknTckn.length !== 11) && !this.isCustomerAliasRegistered()) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Adı</label>
							</div>
							<div className="col-sm-8">
								<div className={"form-group"}>
									<input className="form-control"
										   type="text"
										   name="givenName"
										   id="tGivenName"
										   value={this.props.customer.givenName}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						</div>}

						{this.isCustomerAliasRegistered() &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Adı</label>
							</div>
							<div className="col-sm-8">
								<label>{this.props.customer.givenName ? this.props.customer.givenName : '-'}</label>
							</div>
						</div>}

						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Orta Adı </label>
							</div>
							<div className="col-sm-8 form-group" style={{maxWidth: "none"}}>
								<input className="form-control"
									   type="text"
									   name="middleName"
									   value={this.props.customer.middleName}
									   onChange={(e) => this.props.onChangeCustomer(e)}/>
							</div>
						</div>
					</div>

					<div className="row">
						{(this.props.customer.vknTckn !== null && this.props.customer.vknTckn.length === 11 && !this.isCustomerAliasRegistered()) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Soyadı *</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<div className={"form-group" + this.validateClass('tFamilyName')}>
									<input className="form-control"
										   type="text"
										   name="familyName"
										   id="tFamilyName"
										   data-vlength="1,45"
										   onBlur={this.validateField}
										   ref="tFamilyName"
										   value={this.props.customer.familyName}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tFamilyName') !== "" &&
									<UncontrolledTooltip placement="right" target="tFamilyName" delay={0}>
										{this.validateMessage("tFamilyName")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>}

						{((this.props.customer.vknTckn === null || this.props.customer.vknTckn.length !== 11) && !this.isCustomerAliasRegistered()) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Soyadı</label>
							</div>
							<div className="col-sm-8">
								<div className={"form-group"}>
									<input className="form-control"
										   type="text"
										   name="familyName"
										   id="tFamilyName"
										   value={this.props.customer.familyName}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						</div>}

						{this.isCustomerAliasRegistered() &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Soyadı</label>
							</div>
							<div className="col-sm-8">
								<label>{this.props.customer.familyName ? this.props.customer.familyName : '-'}</label>
							</div>
						</div>}

						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<div className="col-sm-12 row">
									<div className="col-sm-12 row">
										<label>Kurumsal e-Posta *</label>
										{/*<i className="fa fa-info-circle" style={{fontSize: '8px'}} data-toggle="tooltip" title="Ana kullanıcı bilgileri bu e-posta adresine gönderilecektir."></i>*/}
									</div>
								</div>
							</div>

							<div className="col-sm-8">
								<div className={"form-group" + this.validateClass('tCorporateMail')}>
									<MaskedInput className="form-control"
												 type="text"
												 name="corporateMail"
												 id="tCorporateMail"
												 onBlur={() => this.validateField({
													 target: {
														 id: "tCorporateMail",
														 dataset: {vdata: "email", vlength: '1,255'},
														 value: this.props.customer.corporateMail
													 }
												 })}
												 mask={emailMask}
												 inputProps={{vdata: "email", vlength: '1,255'}}
												 placeholder="_________@______.___"
												 ref="tCorporateMail"
												 value={this.props.customer.corporateMail}
												 onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tCorporateMail') !== "" &&
									<UncontrolledTooltip placement="right" target="tCorporateMail" delay={0}>
										{this.validateMessage("tCorporateMail")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className='col-sm-6 row'>
							<div className='col-sm-4'>
								<Label>NACE Kodu</Label>
							</div>
							<div className='col-sm-8'>
								<Select.Async multi
											  value={this.props.naceCodeList}
											  valueRenderer={(e) => this.prepareCustomValue(e)}
											  onValueClick={(e) => this.showNaceOption(e)}
											  onChange={(e) => e && this.props.onChangeNaceCodes(e)}
											  isLoading={true}
											  autoload={false}
											  cache={false}
											  clearable={false}
											  arrowRenderer={this.arrowRenderer}
											  noResultsText="Kayıt bulunamadı."
											  searchPromptText="Arama için en az 1 karakter giriniz."
											  placeholder="NACE kodu veya açıklaması ile arama yapabilirsiniz"
											  loadingPlaceholder="Yükleniyor..."
											  loadOptions={getNaceCodes}
								/>
							</div>
						</div>

						{(this.props.name === 'createEditCustomer' && this.props.mode === 'edit') &&
						(["smart", "kolaysoft"].includes(VirtualHost.conf.resourcePrefix) ? (this.props.currentUser.roleId === 1 || this.props.currentUser.roleId === 4) : (this.props.currentUser.roleId !== 5 && this.props.currentUser.roleId !== 3)) &&
						<div className='col-sm-6 row'>
							<div className='col-sm-4'>
								<Label>Müşteri Durumu</Label>
							</div>
							<div className='col-sm-8'>
								<div className="form-group">
									<Select
										clearable={false}
										className="select-control"
										name="recentlyActive"
										id="tRecentlyActive"
										value={this.props.customer.active}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.onCustomerStatusChange(e)}
										options={customerStatus}
									/>
								</div>
							</div>
						</div>}
					</div>

					<div className="row">
						<div className='col-sm-6 row'>
							<div className='col-sm-4'>
								<Label>KEP Adresi</Label>
							</div>
							<div className='col-sm-8'>
								<div className="form-group">
									<MaskedInput className="form-control"
												 mask={emailMask}
												 placeholder="_________@______.___"
												 type="text"
												 name="kepAdresi"
												 value={this.props.customer.kepAdresi}
												 onChange={(e) => this.props.onChangeCustomer(e)}/>
									{/*<input className="form-control"*/}
									{/*type="text"*/}
									{/*name="kepAdresi"*/}
									{/*value={this.props.customer.kepAdresi}*/}
									{/*onChange={(e) => this.props.onChangeCustomer(e)}/>*/}
								</div>
							</div>
						</div>
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Müşteri No</label>
							</div>
							<div className="col-sm-8 form-group" style={{maxWidth: "none"}}>
								<input className="form-control"
									   type="text"
									   name="customerNo"
									   maxLength={6}
									   value={this.props.customer.customerNo}
									   onChange={(e) => this.props.onChangeCustomer(e)}/>
							</div>
						</div>
					</div>

					<div className="row">
						{this.props.currentUser.registrantImperative &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Müşteri Temsilcisi</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<div className={"form-group" + this.validateClass('tRepresentative')}>
									<input className="form-control"
										   type="text"
										   name="representative"
										   id="tRepresentative"
										   data-vlength="1,45"
										   onBlur={this.validateField}
										   ref="tRepresentative"
										   value={this.props.customer.representative}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
									{this.validateMessage('tRepresentative') !== "" &&
									<UncontrolledTooltip placement="right" target="tRepresentative" delay={0}>
										{this.validateMessage("tRepresentative")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>}

						{!this.props.currentUser.registrantImperative &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Müşteri Temsilcisi</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<div className="form-group">
									<input className="form-control"
										   type="text"
										   name="representative"
										   value={this.props.customer.representative}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						</div>}

						{(EntegratorConf.identifier === EntegratorIdentifiers.KOLAYSOFT || EntegratorConf.identifier === EntegratorIdentifiers.SMART) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<a style={{cursor: "pointer"}} onClick={() => this.setState({informationMailModal: true})}>Bilgilendirme maili almak istiyorum</a>
							</div>

							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="informationMail"
									   value={this.props.customer.informationMail}
									   checked={!!this.props.customer.informationMail}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>}

						{(EntegratorIdentifiers.VEGA === EntegratorConf.identifier || EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>e-Arşiv sms'i gönderilsin</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="earchiveSmsSend"
									   value={this.props.customer.earchiveSmsSend}
									   checked={!!this.props.customer.earchiveSmsSend}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>}
						{ (this.props.name === 'companyProfile' && showBaro()) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>e-SMM  8 günden sonrada iptal etmek istiyorum.</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="cancelPermission"
									   value={this.props.customer.cancelPermission}
									   checked={!!this.props.customer.cancelPermission}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>}

						{ (this.props.name === 'companyProfile' && !showBaro()) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>e-Arşiv Faturaları 8 günden sonra da iptal etmek istiyorum.</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="cancelPermission"
									   value={this.props.customer.cancelPermission}
									   checked={!!this.props.customer.cancelPermission}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>}

						{(this.props && this.props.name === 'companyProfile' && VirtualHost.conf.resourcePrefix === 'cicekfatura') &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Basit üsül mükellef</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="basitUsul"
									   value={this.props.customer.basitUsul}
									   checked={!!this.props.customer.basitUsul}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>}
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Belge Ön Eki şube bazlı olsun.</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="branchBasedPrefixCode"
									   value={this.props.customer.branchBasedPrefixCode}
									   checked={!!this.props.customer.branchBasedPrefixCode}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>KDV oranı kontrol edilsin</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<input type="checkbox" name="checkKdv"
									   value={this.props.customer.checkKdv}
									   checked={!!this.props.customer.checkKdv}
									   onChange={e => this.props.onChangeCustomer(e)}/>
							</div>
						</div>
						<br/>
						<br/>
						<br/>
						{(this.props.name && this.props.name === 'createEditCustomer') &&
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Muhasebeci olarak kaydet</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<input type="checkbox" name="accountant"
										   value={this.props.customer.accountant}
										   checked={!!this.props.customer.accountant}
										   onChange={e => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						}
						{(this.props && this.props.name === 'companyProfile' && !this.props.currentUser.impersonate  && this.props.currentUser.customerId === this.props.customer.recordId) &&
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Muhasebecimin benim adıma fatura kesme yetkisi olsun</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<input type="checkbox" name="invoiceAuthAccountant"
										   value={this.props.customer.invoiceAuthAccountant}
										   checked={!!this.props.customer.invoiceAuthAccountant}
										   onChange={e => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						}
					</div>

					<div className="row">
						{EntegratorIdentifiers.FARMAKOM === EntegratorConf.identifier &&
							<div className="col-sm-12" style={{marginTop: '20px'}}>
								<FaultyDocumentModal
									customerData={this.props.customer}
								/>
							</div>
						}
					</div>
					<br/>
					<br/>

					<div className="row">
						{this.props.currentUser.customerSorumluFields === 'enabled' || (["zirve"].includes(VirtualHost.conf.resourcePrefix)) ?
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Tckn *</label>
								</div>
								<div className="col-sm-8">
									<div className={"form-group" + this.validateClass('tSorumluTckn')}>
										<input className="form-control"
											   maxLength='11'
											   type="text"
											   id="tSorumluTckn"
											   data-vlength="1,45"
											   onBlur={this.validateField}
											   ref="tSorumluTckn"
											   name="sorumluTckn"
											   value={this.props.customer.sorumluTckn}
											   onChange={(e) => this.props.onChangeCustomer(e)}/>
										{this.validateMessage('tSorumluTckn') !== "" &&
										<UncontrolledTooltip placement="right" target="tSorumluTckn" delay={0}>
											{this.validateMessage("tSorumluTckn")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							:
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Tckn</label>
								</div>
								<div className="col-sm-8">
									<div className="form-group">
										<input className="form-control"
											   maxLength='11'
											   type="text"
											   name="sorumluTckn"
											   value={this.props.customer.sorumluTckn}
											   onChange={(e) => this.props.onChangeCustomer(e)}/>
									</div>
								</div>
							</div>}


					</div>

					<div className="row">
						{this.props.currentUser.customerSorumluFields === 'enabled' || (["zirve"].includes(VirtualHost.conf.resourcePrefix)) ?
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Adı *</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className={"form-group" + this.validateClass('tSorumluAd')}>
										<input className="form-control"
											   type="text"
											   id="tSorumluAd"
											   data-vlength="1,45"
											   onBlur={this.validateField}
											   ref="tSorumluAd"
											   name="sorumluAd"
											   value={this.props.customer.sorumluAd}
											   onChange={(e) => this.props.onChangeCustomer(e)}/>
										{this.validateMessage('tSorumluAd') !== "" &&
										<UncontrolledTooltip placement="right" target="tSorumluAd" delay={0}>
											{this.validateMessage("tSorumluAd")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							:
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Adı</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className="form-group">
										<input className="form-control"
											   type="text"
											   name="sorumluAd"
											   value={this.props.customer.sorumluAd}
											   onChange={(e) => this.props.onChangeCustomer(e)}/>
									</div>
								</div>
							</div>}

						{this.props.currentUser.customerSorumluFields === 'enabled' || (["zirve"].includes(VirtualHost.conf.resourcePrefix)) ?
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Soyadı *</label>
								</div>
								<div className="col-sm-8">
									<div className={"form-group" + this.validateClass('tSorumluSoyad')}>
										<input className="form-control"
											   type="text"
											   id="tSorumluSoyad"
											   data-vlength="1,45"
											   onBlur={this.validateField}
											   ref="tSorumluSoyad"
											   name="sorumluSoyad"
											   value={this.props.customer.sorumluSoyad}
											   onChange={(e) => this.props.onChangeCustomer(e)}/>
										{this.validateMessage('tSorumluSoyad') !== "" &&
										<UncontrolledTooltip placement="right" target="tSorumluSoyad" delay={0}>
											{this.validateMessage("tSorumluSoyad")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							:
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Soyadı</label>
								</div>
								<div className="col-sm-8">
									<div className="form-group">
										<input className="form-control"
											   type="text"
											   name="sorumluSoyad"
											   value={this.props.customer.sorumluSoyad}
											   onChange={(e) => this.props.onChangeCustomer(e)}/>
									</div>
								</div>
							</div>}

					</div>

					<div className="row">

						{this.props.currentUser.customerSorumluFields === 'enabled' || (["zirve"].includes(VirtualHost.conf.resourcePrefix))?
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Cep Tel. *</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className={"form-group" + this.validateClass('tSorumluCepTel')}>
										<MaskedInput className="form-control"
													 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
													 placeholder="+90__________"
													 type="text"
													 id="tSorumluCepTel"
													 ref="tSorumluCepTel"
													 inputProps={{vdata: "telphone", vlength: '13,13'}}
													 onBlur={() => this.validateField({
														 target: {
															 id: "tSorumluCepTel",
															 dataset: {vdata: 'telphone', vlength: '13,13'},
															 value: this.props.customer.sorumluCepTel
														 }
													 })}
													 name="sorumluCepTel"
													 value={this.props.customer.sorumluCepTel}
													 onChange={(e) => this.props.onChangeCustomer(e)}/>
										{this.validateMessage('tSorumluCepTel') !== "" &&
										<UncontrolledTooltip placement="right" target="tSorumluCepTel" delay={0}>
											{this.validateMessage("tSorumluCepTel")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							:
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu Cep Tel.</label>
								</div>
								<div className="col-sm-8" style={{maxWidth: "none"}}>
									<div className="form-group">
										<MaskedInput className="form-control"
													 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
													 placeholder="+90__________"
													 type="text"
													 name="sorumluCepTel"
													 value={this.props.customer.sorumluCepTel}
													 onChange={(e) => this.props.onChangeCustomer(e)}/>
									</div>
								</div>
							</div>}

						{this.props.currentUser.customerSorumluFields === 'enabled' || (["zirve"].includes(VirtualHost.conf.resourcePrefix))?
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu e-Posta *</label>
								</div>
								<div className="col-sm-8">
									<div className={"form-group" + this.validateClass('tSorumluEPosta')}>
										<MaskedInput className="form-control"
													 mask={emailMask}
													 placeholder="_________@______.___"
													 type="text"
													 name="sorumluEPosta"
													 id="tSorumluEPosta"
													 onBlur={() => this.validateField({
														 target: {
															 id: "tSorumluEPosta",
															 dataset: {vdata: "email", vlength: '1,255'},
															 value: this.props.customer.sorumluEPosta
														 }
													 })}
													 inputProps={{vdata: "email", vlength: '1,255'}}
													 ref="tSorumluEPosta"
													 value={this.props.customer.sorumluEPosta}
													 onChange={(e) => this.props.onChangeCustomer(e)}/>
										{this.validateMessage('tSorumluEPosta') !== "" &&
										<UncontrolledTooltip placement="right" target="tSorumluEPosta" delay={0}>
											{this.validateMessage("tSorumluEPosta")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							:
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Sorumlu e-Posta</label>
								</div>
								<div className="col-sm-8">
									<div className="form-group">
										<MaskedInput className="form-control"
													 mask={emailMask}
													 placeholder="_________@______.___"
													 type="text"
													 name="sorumluEPosta"
													 value={this.props.customer.sorumluEPosta}
													 onChange={(e) => this.props.onChangeCustomer(e)}/>
									</div>
								</div>
							</div>}
						{(EntegratorIdentifiers.SMART === EntegratorConf.identifier || EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier) &&
								<div className="col-sm-6 row">
									<div className="col-sm-4">
										<label>SMM VKN/TCKN</label>
									</div>
									<div className="col-sm-8">
										<div className="form-group">
											<Input className="form-control"
														 disabled={true}
														 type="text"
														 name="smmVknTckn"
														 value={this.props.accountantInformation?.vknTckn || ''}/>
										</div>
									</div>
								</div>
						}
						{(EntegratorIdentifiers.SMART === EntegratorConf.identifier || EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier) &&
								<div className="col-sm-6 row">
									<div className="col-sm-4">
										<label>SMM Ad Soyad</label>
									</div>
									<div className="col-sm-8">
										<div className="form-group">
											<Input className="form-control"
														 disabled={true}
														 type="text"
														 name="smmVknTckn"
														 value={this.props.accountantInformation?.nameSurname || ''}/>
										</div>
									</div>
								</div>
						}

					</div>

					<div className="row">

						{EntegratorIdentifiers.FARMAKOM === EntegratorConf.identifier && (this.props.currentUser.customerSorumluFields === 'enabled' ?
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Kontör Uyarı Kotası:</label>
								</div>
								<div className="col-sm-8">
									<div className={"form-group" + this.validateClass('tCreditWarningLimit')}>
										<NumberFormat name="tCreditWarningLimit"
													  value={this.props.customer.tCreditWarningLimit}
													  allowNegative={false}
													  isNumericString={true}
													  allowEmptyFormatting={false}
													  displayType="input"
													  isAllowed={values => {
														  return (values.value !== "");
													  }}
													  placeholder=""
													  renderText={value => {
														  value.replace(/\./g, ',')
													  }}
													  onChange={(e) => this.props.onChangeCustomer(e)}
													  className="form-control"/>
										{this.validateMessage('tCreditWarningLimit') !== "" &&
										<UncontrolledTooltip placement="right" target="tCreditWarningLimit" delay={0}>
											{this.validateMessage("tCreditWarningLimit")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							:
							<div className="col-sm-6 row">
								<div className="col-sm-4">
									<label>Kontör Uyarı Kotası:</label>
								</div>
								<div className="col-sm-8">
									<div className="form-group">
										<NumberFormat name="creditWarningLimit"
													  value={this.props.customer.creditWarningLimit}
													  allowNegative={false}
													  isNumericString={true}
													  allowEmptyFormatting={false}
													  displayType="input"
													  isAllowed={values => {
														  return (values.value !== "");
													  }}
													  placeholder=""
													  renderText={value => {
														  value.replace(/\./g, ',')
													  }}
													  onChange={(e) => this.props.onChangeCustomer(e)}
													  className="form-control"/>
									</div>
								</div>
							</div>)}

					</div>

					<br/>

					{(this.props.name && this.props.name === 'createEditCustomer') &&
					<div style={{marginTop: '30px'}}>
						<Row>
							<Col xs='12' sm='6' md='3'>
								<Label check>
									<Input type="checkbox" name="distributor"
										   value={this.props.customer.distributor}
										   checked={!!this.props.customer.distributor} bsSize={"15px"}
										   disabled={((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
											   EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
											   EntegratorIdentifiers.MBT === EntegratorConf.identifier) && this.props.currentUser && (this.props.currentUser.roleId === 3) ||
											   (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4))}
										   onChange={e => this.onCheckDistributor(e)}/>{' '}
									Bayi olarak kaydet
								</Label>
							</Col>
						</Row>
						{this.props.customer.distributor &&
						<Row style={{
							display: 'block',
							borderRadius: '5px',
							margin: '15px'
						}}>
							<Row>
								{this.state.isCustomerEntegrator &&
								(this.props.currentUser.isEntegrator &&
									(EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
								EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
								EntegratorIdentifiers.MBT === EntegratorConf.identifier ||
								EntegratorIdentifiers.BYM === EntegratorConf.identifier ||
								EntegratorIdentifiers.AKTIF === EntegratorConf.identifier)) &&
								<Col xs='12' sm='6' md='3'>
									<div style={{display: 'flex'}}>
										<div style={{width: '50%'}}>
											<label>Çalışma Şekli:</label>
										</div>

										<div style={{width: '50%'}} className={"form-group" + this.validateClass('workingType')}>
											<Select
												clearable={false}
												className="select-control"
												name="workingType"
												id="workingType"
												onBlur={() => this.validateField({
													target: {
														id: "workingType",
														dataset: {vdata: "required"},
														value: this.props.customer.workType
													}
												})}
												ref="workingType"
												inputProps={{'vdata': "required"}}
												value={this.props.customer.workType}
												placeholder="Seçiniz..."
												style={this.selectStyle('workingType')}
												onChange={(e) => e && this.props.onInvoiceWorkTypeChange(e)}
												options={[
													{value: 1, label: "Müşteri Kendi Öder"},
													{value: 2, label: "Bayi Müşteri Adına Öder"},
													{value: 3, label: "Bayi Toplu Kontor Alır"}
												]}
											/>
											{this.validateMessage('workingType') !== "" &&
												<UncontrolledTooltip placement="right" target="workingType" delay={0}>
													{this.validateMessage("workingType")}
												</UncontrolledTooltip>}
										</div>
									</div>
								</Col>}
								{(this.props.currentUser.isEntegrator && (VirtualHost.conf.resourcePrefix === 'smart' || VirtualHost.conf.resourcePrefix === 'kolaysoft')) &&
								<Col xs='12' sm='6' md='3'>
									<div style={{display: 'flex'}}>
										<div style={{width: '50%'}}>
											<label>Faturalandırma Yöntemi:</label>
										</div>
										<div style={{width: '50%'}} className={"form-group" + this.validateClass('tInvoiceDirection')}>
											<Select
												clearable={false}
												className="select-control"
												name="invoiceDirection"
												id="tInvoiceDirection"
												onBlur={() => this.validateField({
													target: {
														id: "tInvoiceDirection",
														dataset: {vdata: "required"},
														value: this.props.customer.invoiceDirection
													}
												})}
												inputProps={{'vdata': "required"}}
												ref="tInvoiceDirection"
												value={this.props.customer.invoiceDirection}
												placeholder="Seçiniz..."
												style={this.selectStyle('tInvoiceDirection')}
												onChange={(e) => e && this.props.onInvoiceDirectionChange(e)}
												options={[
													{value: 0, label: "Faturayı Bayi Keser"},
													{value: 1, label: "Faturayı Entegratör Keser"}
												]}
											/>
											{this.validateMessage('tInvoiceDirection') !== "" &&
												<UncontrolledTooltip placement="right" target="tInvoiceDirection" delay={0}>
													{this.validateMessage("tInvoiceDirection")}
												</UncontrolledTooltip>}
										</div>
									</div>
								</Col>}
								{(this.props.currentUser.isEntegrator && (VirtualHost.conf.resourcePrefix === 'smart' || VirtualHost.conf.resourcePrefix === 'kolaysoft')) &&
								<Col xs='12' sm='6' md='3'>
									<div style={{display: 'flex'}}>
										<div style={{width: '50%'}}>
											<label>Bayi Portal Adresi:</label>
										</div>
										<div style={{width: '50%'}} className={"form-group"}>
											<input className="form-control"
												   type="url"
												   name="portalAddress"
												   id="portalAddress"
												   data-vlength="0,255"
												   onBlur={this.validateField}
												   ref="portalAddress"
												   value={this.props.customer.portalAddress}
												   onChange={(e) => this.props.onChangeCustomer(e)}/>
										</div>
									</div>
								</Col>}
								{this.state.isCustomerEntegrator &&
								(this.props.currentUser.isEntegrator && (EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
								EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
								EntegratorIdentifiers.MBT === EntegratorConf.identifier)) &&
								<Col xs='12' sm='6' md='3'>
									<div style={{display: 'flex'}}>
										<div style={{width: '50%'}}>
											<label>Marka Bayiliği:</label>
										</div>
										<div style={{width: '50%'}} className={"form-group"}>
											<input className="form-control"
												   type="text"
												   name="brandFranchising"
												   id="brandFranchising"
												   data-vlength="0,255"
												   onBlur={this.validateField}
												   ref="brandFranchising"
												   value={this.props.customer.brandFranchising}
												   onChange={(e) => this.props.onChangeCustomer(e)}/>
										</div>
									</div>
								</Col>}
								{this.state.isCustomerEntegrator &&
									(this.props.currentUser.isEntegrator && (EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
										EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
										EntegratorIdentifiers.MBT === EntegratorConf.identifier)) &&
								<Col xs='12' sm='6' md='3'>
									<div style={{display: 'flex'}}>
										<div style={{width: '50%'}}>
											<label>e-Ticaret Sitesi:</label>
										</div>
										<div style={{width: '50%'}} className={"form-group"}>
											<input className="form-control"
												   type="url"
												   name="ecommerceSite"
												   id="ecommerceSite"
												   data-vlength="0,255"
												   onBlur={this.validateField}
												   ref="ecommerceSite"
												   value={this.props.customer.ecommerceSite}
												   onChange={(e) => this.props.onChangeCustomer(e)}/>
										</div>
									</div>
								</Col>}
								{this.state.isCustomerEntegrator &&
									(this.props.currentUser.isEntegrator && (EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
										EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
										EntegratorIdentifiers.MBT === EntegratorConf.identifier)) &&
								<Col xs='12' sm='6' md='3'>
									<div style={{display: 'flex'}}>
										<div style={{width: '50%'}}>
											<Label>Entegrasyon Durumu:</Label>
										</div>
										<div style={{width: '50%'}}>
											<Switch
												checked={!!this.props.customer.integrationStatus}
												disabled={false}
												onChange={(e) => this.props.onChangeCustomer({
													target: {
														value: e,
														name: "integrationStatus"
													}
												})}
												onColor="#86d3ff"
												onHandleColor="#2693e6"
												handleDiameter={20}
												uncheckedIcon={false}
												checkedIcon={false}
												boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
												activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
												height={15}
												width={30}
												className="react-switch"
											/>
										</div>
									</div>
								</Col>}
							</Row>


						</Row>
						}


						<Row>
							<Col xs='12'>
								<Label check>
									<Input disabled={!this.props.customer.distributor}
										   onChange={e => this.props.onChangeCustomer(e)}
										   value={this.props.customer.distributor ? this.props.customer.allowPrivateAccess : false}
										   name="allowPrivateAccess"
										   checked={!!this.props.customer.allowPrivateAccess} type="checkbox"
										   bsSize={"15px"}/>{' '}
									Bayi müşteri portalına erişebilir
								</Label>
							</Col>
						</Row>
						{showDistributorAllowCreditChange(this.props.isEntegrator, EntegratorConf.identifier, this.props.currentUser.adminUser) &&
						<Row style={{display: this.props.currentUser.adminUser ? 'block' : 'none' }}>
							<Col xs='12'>
								<Label check>
									<Input disabled={!this.props.customer.distributor || this.props.customer.workType==1}
										   onChange={e => this.props.onChangeCustomer(e)}
										   value={this.props.customer.distributor ? this.props.customer.allowCreditChange : false}
										   name="allowCreditChange"
										   checked={!!this.props.customer.allowCreditChange} type="checkbox"
										   bsSize={"15px"}/>{' '}
									Bayi kontör işlemlerine erişebilir
								</Label>
							</Col>
						</Row>}
						<br/>
						<br/>
						{(this.props.isEntegrator || (this.props.isDistributor && showKolayAndSmart(EntegratorConf.identifier))) &&
						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label>Müşteriye Bayi Ata</label>
							</div>
							<div className="col-sm-8">
								<div className={"form-group" + this.validateClass('tDistributor')}>
									<Select
										disabled={
										   ((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
											 EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
											 EntegratorIdentifiers.MBT === EntegratorConf.identifier
											) && ((!this.props.currentUser.adminUser && this.props.currentUser.roleId !== 4)) ||
											(this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4))
										}
										clearable={false}
										className="select-control"
										name="distributor"
										id="tDistributor"
										ref="tDistributor"
										value={this.state.selectedDistributor}
										placeholder="Seçiniz..."
										style={this.selectStyle('tDistributor')}
										onChange={(e) => e && this.onDistributorChange(e)}
										onInputChange={(inputValue) => this.handleSearch(inputValue)}
										options={this.state.filteredDistributorList
												.filter(distributor => distributor[0] != this.props.customer.recordId)
												.map(distributor => (
													{value: distributor[0], label: this.getDistributorName(distributor)}
												))
										}
									/>
									{this.validateMessage('tDistributor') !== "" &&
									<UncontrolledTooltip placement="right" target="tDistributor" delay={0}>
										{this.validateMessage("tDistributor")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>}
					</div>}
				</div>


				{this.props.currentUser.registrantImperative &&
				<hr style={{margin: '40px 0 20px 0'}}/>}

				{this.props.currentUser.registrantImperative &&
				<Row>
					<Col xs='12' style={{marginBottom: '10px'}}>
						<h4>Müşteri Kaydını Alan Kişinin:</h4>
					</Col>
				</Row>}

				{this.props.currentUser.registrantImperative &&
				<div className="row">
					<div className="col-sm-4">
						<div className="col-sm-4">
							<label>Adı</label>
						</div>
						<div className="col-sm-8" style={{maxWidth: "none"}}>
							<div className={"form-group" + this.validateClass('tRegistrantName')}>
								<input className="form-control"
									   type="text"
									   name="registrantName"
									   id="tRegistrantName"
									   data-vlength="1,45"
									   onBlur={this.validateField}
									   ref="tRegistrantName"
									   value={this.props.customer.registrantName}
									   onChange={(e) => this.props.onChangeCustomer(e)}/>
								{this.validateMessage('tRegistrantName') !== "" &&
								<UncontrolledTooltip placement="right" target="tRegistrantName" delay={0}>
									{this.validateMessage("tRegistrantName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>

					<div className="col-sm-4">
						<div className="col-sm-4">
							<label>Soyadı</label>
						</div>
						<div className="col-sm-8" style={{maxWidth: "none"}}>
							<div className={"form-group" + this.validateClass('tRegistrantSurname')}>
								<input className="form-control"
									   type="text"
									   name="registrantSurname"
									   id="tRegistrantSurname"
									   data-vlength="1,45"
									   onBlur={this.validateField}
									   ref="tRegistrantSurname"
									   value={this.props.customer.registrantSurname}
									   onChange={(e) => this.props.onChangeCustomer(e)}/>
								{this.validateMessage('tRegistrantSurname') !== "" &&
								<UncontrolledTooltip placement="right" target="tRegistrantSurname" delay={0}>
									{this.validateMessage("tRegistrantSurname")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>

					<div className="col-sm-4">
						<div className="col-sm-4">
							<label>Cep No</label>
						</div>
						<div className="col-sm-8" style={{maxWidth: "none"}}>
							<div className={"form-group" + this.validateClass('tRegistrantMobile')}>
								<MaskedInput className="form-control"
											 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
											 placeholder="+90__________"
											 type="text"
											 name="registrantMobile"
											 id="tRegistrantMobile"
											 onBlur={() => this.validateField({
												 target: {
													 id: "tRegistrantMobile",
													 dataset: {vdata: "phone", vlength: '1,13'},
													 value: this.props.customer.registrantMobile
												 }
											 })}
											 ref="tRegistrantMobile"
											 inputProps={{vdata: "phone", vlength: '1,13'}}
											 value={this.props.customer.registrantMobile}
											 onChange={(e) => this.props.onChangeCustomer(e)}/>
								{this.validateMessage('tRegistrantMobile') !== "" &&
								<UncontrolledTooltip placement="right" target="tRegistrantMobile" delay={0}>
									{this.validateMessage("tRegistrantMobile")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				</div>}


				<hr style={{margin: '40px 0 40px 0'}}/>

				<Modal isOpen={this.state.naceModal} size="md">
					<ModalHeader toggle={this.closeNaceModal}>NACE kodu</ModalHeader>
					<ModalBody>{this.state.selectedNaceOption}</ModalBody>
				</Modal>

				{this.state.informationMailModal &&
				<InformationMailModal
					informationMailChange={this.informationMailChange}
					informationMail={this.props.customer.informationMail}
					currentUser={this.props.customer}
					isSmart={EntegratorIdentifiers.SMART === EntegratorConf.identifier}
					informationMailModal={this.state.informationMailModal}
					toggleModal={() => this.setState({informationMailModal:false})}
				/>
				}

			</div>
		)
	}
}

export default CustomerGeneralInfo;